import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { NgxFhirQnrFormsRoutingModule } from '@hestia/ngx-fhir-qnr-forms';
import { HestiaMitIdCallbackComponent } from '@hestia/ngx-mitid';
import { AuthGuard, AuthNoneGuard, IsAuthenticatedRouteGuard, IsUnauthenticatedRouteGuard } from '@hestia/ngx-user';

import {
  FinishCompletedRouteGuard,
  IntroCompletedRouteGuard,
  IntroNotCompletedRouteGuard,
} from './guards/intro-status.guard';
import { SdqCompletedRouteGuard, SdqNotCompletedRouteGuard } from './guards/sdq-status.guard';
import { DawbaRoutes } from './route-constants';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/login.page/login.page.module').then((m) => m.LoginPageModule),
    canActivate: [AuthNoneGuard],
  },
  {
    canActivate: [AuthGuard, FinishCompletedRouteGuard, IntroNotCompletedRouteGuard],
    path: DawbaRoutes.IntroToIntroPage,
    loadChildren: () =>
      import('./pages/intro-to-intro.page/intro-to-intro.page.module').then((m) => m.IntroToIntroPageModule),
  },
  {
    canActivate: [AuthGuard, FinishCompletedRouteGuard, IntroCompletedRouteGuard],
    path: DawbaRoutes.IntroToSsdqPage,
    loadChildren: () =>
      import('./pages/intro-to-ssdq.page/intro-to-ssdq.page.module').then((m) => m.IntroToSsdqPageModule),
  },
  {
    path: DawbaRoutes.DashboardPage,
    canActivate: [AuthGuard, FinishCompletedRouteGuard, SdqCompletedRouteGuard],
    loadChildren: () => import('./pages/dashboard.page/dashboard.page.module').then((m) => m.DashboardPageModule),
  },
  {
    path: DawbaRoutes.ExitPage,
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/exit.page/exit.page.module').then((m) => m.ExitPageModule),
  },
  {
    path: DawbaRoutes.ChoosePatientPage,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/choose-patient.page/choose-patient.page.module').then((m) => m.ChoosePatientPageModule),
  },
  {
    path: DawbaRoutes.OnboardingPage,
    canActivate: [AuthGuard, FinishCompletedRouteGuard],
    loadChildren: () => import('./pages/onboarding.page/onboarding.page.module').then((m) => m.OnboardingPageModule),
  },
  {
    path: DawbaRoutes.NoTaskAvailablePage,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/no-task-available.page/no-task-available.page.module').then((m) => m.NoTaskAvailablePageModule),
  },
  {
    path: DawbaRoutes.InactiveLogoutConfirm,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/logout-confirm.page/logout-confirm.page.module').then((m) => m.LogoutConfirmPageModule),
  },
  {
    canActivate: [AuthGuard],
    path: DawbaRoutes.QuestionnairePage,
    loadChildren: () => NgxFhirQnrFormsRoutingModule,
  },
  /*  {
    canActivate: [IsAuthenticatedRouteGuard, FinishCompletedRouteGuard, SdqNotCompletedRouteGuard],
    path: DawbaRoutes.IntroToSsdqPage,
    loadChildren: () =>
      import('./pages/intro-to-ssdq.page/intro-to-ssdq.page.module').then(
        (m) => m.IntroToSsdqPageModule
      ),
  },*/
  {
    path: DawbaRoutes.MitIdCallback,
    component: HestiaMitIdCallbackComponent,
  },
  {
    path: 'py/routines/clickhere.py',
    loadChildren: () => import('./pages/qnr-info.page/qnr-info.page.module').then((m) => m.QnrInfoPageModule),
    pathMatch: 'prefix',
  },
  {
    path: DawbaRoutes.DevAdminPage,
    loadChildren: () => import('./pages/dev-admin.page/dev-admin.page.module').then((m) => m.DevAdminPageModule),
  },
  {
    path: '**',
    loadChildren: () => import('./pages/error.page/error.page.module').then((m) => m.ErrorPageModule),
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
